import { AppBase, GraphNode, Mesh as PcMesh, Model, MeshInstance, StandardMaterial } from 'playcanvas';

import type { ObjParseResult } from './obj-parser';

// Build a PlayCanvas Model from parsed OBJ data
export function buildModelFromObj(app: AppBase, parsed: ObjParseResult): Model {
    const gd = app.graphicsDevice;

    const root = new GraphNode('obj-root');
    const model = new Model();
    (model as any).graph = root;
    (model as any).meshInstances = [] as MeshInstance[];

    const pc: any = (window as any).pc;
    const PRIMITIVE_TRIANGLES = pc?.PRIMITIVE_TRIANGLES ?? 4;

    for (const group of parsed.groups) {
        // Skip empty groups (no triangles or vertices)
        const vertCount = Math.floor(group.positions.length / 3);
        console.log('OBJ group summary', { name: group.name, verts: vertCount, indices: group.indices.length, uvs: (group.uvs && group.uvs.length) || 0, normals: (group.normals && group.normals.length) || 0 });
        if (!vertCount || group.indices.length < 3) {
            continue;
        }

        // Create mesh
        const mesh = new PcMesh(gd);
        (mesh as any).setPositions(group.positions);
        (mesh as any).setNormals(group.normals);

        // Only set UVs if count matches vertices
        const expectedUvLen = vertCount * 2;
        if (group.uvs && group.uvs.length === expectedUvLen) {
            if (typeof (mesh as any).setUvs === 'function') {
                try {
                    (mesh as any).setUvs(0, group.uvs);
                } catch (e) {
                    try {
                        (mesh as any).setUvs(group.uvs);
                    } catch (e2) { /* ignore */ }
                }
            }
        }

        (mesh as any).setIndices(group.indices);
        (mesh as any).update(PRIMITIVE_TRIANGLES);

        // Create material named after group for later MTL texture mapping
        const material = new StandardMaterial();
        (material as any).name = group.name || 'obj-material';
        (material as any).depthTest = true;
        (material as any).depthWrite = true;
        material.update();

        // MeshInstance
        const mi = new MeshInstance(mesh, material, root);
        ((model as any).meshInstances as MeshInstance[]).push(mi);
    }

    // If no mesh instances were created, surface a helpful error
    if (!((model as any).meshInstances as MeshInstance[]).length) {
        throw new Error('OBJ contains no renderable triangles');
    }

    return model;
}
